class Google {
    load = (appId) => {
        return new Promise((resolve, reject) => {
            const meta1 = document.createElement('meta');
            meta1.name = "google-signin-scope";
            meta1.content = "profile email";
            document.head.appendChild(meta1);

            const clientIdString = appId + '.apps.googleusercontent.com';
            const meta2 = document.createElement('meta');
            meta2.name = "google-signin-client_id";
            meta2.content = clientIdString;
            document.head.appendChild(meta2);

            const script = document.createElement('script');
            script.src = 'https://apis.google.com/js/platform.js';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.init(appId).then(() => {
                    resolve();
                });
            };
            document.body.appendChild(script);
        });
    };

    init = (appId) => {
        const clientIdString = appId + '.apps.googleusercontent.com';

        return new Promise((resolve, reject) => {
            gapi.load('client:auth2', () => {
                //Retrieve the singleton for the GoogleAuth library and set up the client.
                this.auth2 = gapi.auth2.init({
                    client_id: clientIdString,
                    cookiepolicy: 'single_host_origin',
                });
                resolve();
            });
        });
    };

    signIn(element) {
        return new Promise((resolve, reject) => {
            this.auth2.attachClickHandler(element, {},
                (googleUser) => {
                    this.googleUser = googleUser;
                    const authResponse = googleUser.getAuthResponse();
                    const accessToken = authResponse['id_token'];
                    const expiresIn = authResponse['expires_in'];
                    const authObject = {
                        accessToken,
                        expiresIn
                    };
                    resolve(authObject);
                }, (error) => {
                    reject(JSON.stringify(error, undefined, 2));
                });
        });
    }

    getUserObject() {
        return new Promise((resolve) => {
            const profile = this.googleUser.getBasicProfile();
            const id = profile.getId();
            const username = profile.getGivenName() + '_' + profile.getFamilyName();
            const email = profile.getEmail();
            const user = {
                id,
                username,
                email
            };
            resolve(user);
        });
    }
}

const instance = new Google();

export default instance;
